import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BaseGrid from '../Common/BaseGrid';

function KitSelector(props) {
  const { onSelect } = props;

  const selectItem = (kit) => {
    onSelect(kit);
  };

  return (
    <BaseGrid
      url="/api/inventory/kit"
      hasSearch
      config={{
        columns: {
          stock_id: { label: 'Stock ID', sort: true },
          sku: { label: 'SKU', sort: true },
          qty: { label: 'Qty', sort: true },
          actions: {
            label: 'Actions',
            actions: [
              {
                key: 'select_kit',
                icon: 'mdi mdi-check-bold',
                class: 'btn btn-sm btn-soft-info text-dark',
                alt: 'Select',
                click: selectItem,
              },
            ],
          },
        },
        pagination: {
          sort: 'stock_id',
          direction: 'asc',
          perPage: 5,
        },
      }}
    />
  );
}

KitSelector.defaultProps = {
  onSelect: () => {},
};

KitSelector.propTypes = {
  onSelect: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(KitSelector));
